import React from 'react';
import { useDispatch } from 'react-redux';
import { INSUFFICIENT_CREDITS, ymcaLoginAction } from './YmcaLoginAction';
import { ActionType } from '../../core/redux/actionType';
import { Route, useLocation } from 'react-router-dom';
import { parseQueryToKeyedStrings } from '../../navigation/module';
import { useLoading } from '../../core/api/hooks';
import { getError } from '../../core/api/module';
import { useAppState } from '../../core/redux/hooks';
import { useMount } from '../../core/hooks/useMount';
import { css } from '@emotion/core';


const styles = {
  page:    css`
    margin-top: 60px;
    text-align: center;
  `,
  header: css`
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
  `,
}

type Props = {
  className?: string;
};

type queryProps = {
  projectid?: string;
  returnURL?: string;
};


const YmcaLoginPage: React.FC<Props> = props => {
  const dispatch = useDispatch();

  const location = useLocation();
  const queryObj = parseQueryToKeyedStrings<queryProps>(location.search);

  const loginErrorMsg = useAppState(state => getError(state, ActionType.YmcaLoginRequest)?.errorMsg);
  const loginErrorCode = useAppState(state => getError(state, ActionType.YmcaLoginRequest)?.extras?.code);
  const isLoggingIn = useLoading(ActionType.YmcaLoginRequest);
  const ymcaSso     = useAppState(state => state.auth.ssoRedirect);

  useMount(() => { dispatch(ymcaLoginAction(queryObj.projectid, queryObj.returnURL)); });

  const displayMessage = loginErrorCode === INSUFFICIENT_CREDITS
    ? 'This project is out of enrollment credits. Please contact your administrator.'
    : loginErrorMsg || 'Error';

  return (
    <div css={styles.page}>
      <div css={styles.header}>YMCA Login</div>
      {
        isLoggingIn && (
          <div>Redirecting...</div>
        )
      }
      {
        !!loginErrorMsg && (
          <div>{displayMessage}</div>
        )
      }
      {
        !!ymcaSso && (
          <Route path='/' render={() => (window.location.href = ymcaSso.redirectUrl)} />
        )
      }
    </div>
  );
};

export default YmcaLoginPage;
